/*
*
* File JS componente Discover component
*
*/

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './discover.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const discover = () => {
    const territories = document.querySelectorAll('.territory-holder');

    territories.forEach(territory => {
        territory.addEventListener('click', () => {
            // Remove 'opened' class from all territories
            territories.forEach(otherTerritory => {
                if (otherTerritory !== territory) {
                    otherTerritory.classList.remove('opened');
                }
            });

            // Toggle 'opened' class on clicked territory
            territory.classList.toggle('opened');
        });
    });
}

export default discover;

//--------------------------------------------------------------------//